export const getOpenGraphImageLink = (props: {
  locale: string;
  siteTitle: string;
  title?: string;
  description?: string;
  readTime?: number;
}) => {
  const ogImageLinkParams = new URLSearchParams();

  ogImageLinkParams.set('locale', props.locale);
  ogImageLinkParams.set('siteTitle', props.siteTitle);
  ogImageLinkParams.set('title', props.title || '');
  ogImageLinkParams.set('description', props.description || '');
  ogImageLinkParams.set('readingTime', props.readTime?.toString() || '');

  const ogImageLink = `/api/og/getImage?${ogImageLinkParams.toString()}`;

  return ogImageLink;
};
